import { getBagById, Bag, getCustomerBagByCountry } from "@repo/apis/bag";
import { ExpandedBag } from "..";
import { cache } from "../utils/cache";
import { buildBagExpansionsForApiInteraction } from "../utils/expansions";
import { handleApiInteractionError } from "../utils/handle-api-interaction-error";
import { handleApiInteractionSuccess } from "../utils/handle-api-interaction-success";
import { BagSdkMethod } from "../utils/method-initialiser";

type PublicGetBagMethod = {
  (params: { expand: true }): Promise<ExpandedBag>;
  (params: { expand?: false }): Promise<Bag>;
};
type GetBagMethod = BagSdkMethod<PublicGetBagMethod>;

export const getBagInitialiser: GetBagMethod = (config) =>
  (async ({ expand }) => {
    const {
      chameleonRequestInstance,
      store,
      lang,
      getAuthHeader,
      country,
      keyStoreDataversion,
    } = config;
    const bagSummary = await cache.getSummary(config);

    const bagId = bagSummary?.bagId;
    const authHeader = await getAuthHeader();

    const bagExpansions = buildBagExpansionsForApiInteraction({
      expand,
    });

    try {
      const response = bagId
        ? await getBagById({
            chameleonRequestInstance,
            store,
            lang,
            bagId,
            expand: bagExpansions,
            authHeader,
          })
        : await getCustomerBagByCountry({
            chameleonRequestInstance,
            store,
            lang,
            customerId: (await config.getIdTokenClaims()).customerId,
            country,
            keyStoreDataversion,
            authHeader,
            expand: bagExpansions,
          });

      await handleApiInteractionSuccess(config, {
        bag: response.data.bag,
        sessionToken: response.bagSessionToken,
      });

      return response.data.bag;
    } catch (error: unknown) {
      return await handleApiInteractionError(config, error);
    }
  }) as PublicGetBagMethod;
